<template>
  <div class="flower" @click="bindClick">
    <div
      class="flower-icon image-flower"
      :class="{ 'image-flower-animate': isAnimate }"
      :style="{ animationDuration: animationDuration }"
      v-if="value"
    >
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/578ce30ce5e125a4cd7742ef9719b796.png"
        alt=""
      />
    </div>
    <div class="flower-icon image-not-flower" v-else>
      <img
        class="image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/578ce30ce5e125a4cd7742ef9719b796.png"
        alt=""
      />
    </div>
    <canvas
      v-if="disabledClick"
      id="canvas-confetti"
      class="canvas-confetti"
      ref="confetti"
    ></canvas>
  </div>
</template>
<script>
const confetti = require('canvas-confetti')
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isAnimate: false,
      delay: 400,
      myConfetti: null,
      disabledClick: false,
      clientY: 0
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.playFlower()
      }
    }
  },
  computed: {
    animationDuration() {
      return this.delay / 1000 + 's'
    }
  },
  created() {},
  methods: {
    playConfetti(position) {
      this.$nextTick(() => {
        this.myConfetti = confetti.create(
          document.getElementById('canvas-confetti'),
          {
            resize: true,
            useWorker: true
          }
        )
        /*   var heart = confetti.default.shapeFromPath({
                      path: 'M167 72c19,-38 37,-56 75,-56 42,0 76,33 76,75 0,76 -76,151 -151,227 -76,-76 -151,-151 -151,-227 0,-42 33,-75 75,-75 38,0 57,18 76,56z',
                      matrix: [0.03333333333333333, 0, 0, 0.03333333333333333, -5.566666666666666, -5.533333333333333]
                  }); */
        this.myConfetti({
          particleCount: 100,
          spread: 70,
          origin: { y: position }
        })
          .then(() => {
            this.disabledClick = false
          })
          .catch(() => {
            this.disabledClick = false
          })
      })
    },
    playFlower() {
      this.isAnimate = true
      this.disabledClick = true
      this.playConfetti(this.clientY / window.screen.height)
      setTimeout(() => {
        this.isAnimate = false
      }, this.delay)
    },
    bindClick(e) {
      if (this.disabledClick) {
        return
      }
      this.clientY = e.clientY
      this.$emit('flower')
    }
  }
}
</script>
<style lang="scss">
.flower {
  width: 56px;
  height: 56px;
  position: relative;

  .canvas-confetti {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 999;
  }

  .flower-icon {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;

    .image {
      width: 32px;
      height: 37px;
    }
  }

  .image-not-flower {
    background: #ffffff;
    z-index: 1;
  }

  .image-flower {
    background: #eaeaea;
    z-index: 2;
  }

  .image-flower-animate {
    animation: myscale 0.3s ease-in;
  }
}

@keyframes myscale {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
</style>
